import { ReactNode } from 'react';

import { FormattedMessage } from '@flipster/i18n';

export type HistoryTabGroup = 'Perpetual' | 'Spot' | 'Transaction';

export interface HistoryTab {
  group: HistoryTabGroup;
  label: ReactNode;
  value: string;
  hideOnSpotOnly?: boolean;
}

export const PerpetualHistoryTabList: HistoryTab[] = [
  {
    group: 'Perpetual',
    label: <FormattedMessage id='Navigation.r250401.Position' />,
    value: '/history/perpetual/position',
  },
  {
    group: 'Perpetual',
    label: <FormattedMessage id='Autogen_Common.r251126.s_PnL' />,
    value: '/history/perpetual/pnl',
  },
  {
    group: 'Perpetual',
    label: <FormattedMessage id='Common.r251107.Funding' />,
    value: '/history/perpetual/funding',
  },
  {
    group: 'Perpetual',
    label: <FormattedMessage id='Common.r250401.Trade' />,
    value: '/history/perpetual/trade',
  },
  {
    group: 'Perpetual',
    label: <FormattedMessage id='Assets.r250401.Profit_boost' />,
    value: '/history/perpetual/profit-boost',
  },
  {
    group: 'Perpetual',
    label: <FormattedMessage id='Assets.r250401.Airdrop' />,
    value: '/history/perpetual/airdrop',
  },
];

export const SpotHistoryTabList: HistoryTab[] = [
  {
    group: 'Spot',
    label: <FormattedMessage id='Autogen_Common.r251126.s_PnL' />,
    value: '/history/spot/pnl',
  },
  {
    group: 'Spot',
    label: <FormattedMessage id='Common.r250401.Trade' />,
    value: '/history/spot/trade',
  },
];

export const TransactionHistoryTabList: HistoryTab[] = [
  {
    group: 'Transaction',
    label: <FormattedMessage id='Navigation.r250401.Earn' />,
    value: '/history/transaction/earn',
    hideOnSpotOnly: true,
  },
  {
    group: 'Transaction',
    label: <FormattedMessage id='Navigation.r250401.Launchpool_reward' />,
    value: '/history/transaction/launchpool-reward',
    hideOnSpotOnly: true,
  },
  {
    group: 'Transaction',
    label: <FormattedMessage id='Common.r251107.Deposit' />,
    value: '/history/transaction/deposit',
  },
  {
    group: 'Transaction',
    label: <FormattedMessage id='Navigation.r250401.Withdrawal' />,
    value: '/history/transaction/withdrawal',
  },
  {
    group: 'Transaction',
    label: <FormattedMessage id='Navigation.r250401.Conversion' />,
    value: '/history/transaction/conversion',
  },
  {
    group: 'Transaction',
    label: <FormattedMessage id='Navigation.r251107.Copy_trading' />,
    value: '/history/transaction/copy-trading',
    hideOnSpotOnly: true,
  },
  {
    group: 'Transaction',
    label: <FormattedMessage id='Navigation.r250818.Referral_affiliate' />,
    value: '/history/transaction/referral-and-affiliate',
    hideOnSpotOnly: true,
  },
];

export const HistoryTabList = [
  {
    label: 'Perpetual',
    value: <FormattedMessage id='Assets.r250401.Perpetual' />,
    hideOnSpotOnly: true,
  },
  {
    label: 'Spot',
    value: <FormattedMessage id='Assets.r250401.Spot' />,
  },
  {
    label: 'Transaction',
    value: <FormattedMessage id='Autogen_common.r251126.s_Transaction' />,
  },
];

export const getTabList = (historyTabGroup: HistoryTabGroup, isSpotOnly: boolean) => {
  const tabList = (() => {
    switch (historyTabGroup) {
      case 'Perpetual':
        return PerpetualHistoryTabList;
      case 'Spot':
        return SpotHistoryTabList;
      case 'Transaction':
        return TransactionHistoryTabList;
      default:
        return [];
    }
  })();

  return isSpotOnly ? tabList.filter((tabItem) => !tabItem.hideOnSpotOnly) : tabList;
};

export const getHistoryTabList = (isSpotOnly: boolean): { label: ReactNode; value: HistoryTabGroup }[] => {
  return [
    ...(isSpotOnly
      ? []
      : ([{ label: <FormattedMessage id='Assets.r250401.Perpetual' />, value: 'Perpetual' }] as const)),
    {
      label: <FormattedMessage id='Assets.r250401.Spot' />,
      value: 'Spot',
    },
    {
      label: <FormattedMessage id='Autogen_common.r251126.s_Transaction' />,
      value: 'Transaction',
    },
  ];
};

export enum PnlHistoryType {
  Perpetual = 'PNL_HISTORY_TYPE_FUTURES',
  Spot = 'PNL_HISTORY_TYPE_SPOT',
}

export const IntervalUnitItems = [
  { label: <FormattedMessage id='Autogen_common.r251126.s_Daily' />, value: '1d' },
  { label: <FormattedMessage id='Autogen_common.r251126.s_Hourly' />, value: '1h' },
];
